<template>
  <b-card>
    <b-row class="mb-1">
      <b-col md="4">
        <b-form-input
          v-model="firstDate"
          type="date"
        />
      </b-col>
      <b-col md="4">
        <b-form-input
          v-model="lastDate"
          type="date"
        />
      </b-col>
      <b-col md="4">
        <b-form-select
          v-model="filterStatus"
          :options="optionsStatus"
        />
      </b-col>
    </b-row>
    <b-table
      class="text-center"
      :fields="fields"
      :items="filteredArray"
      :per-page="10"
      :current-page="currentPage"
      hover
      responsive="xl"
      @row-clicked="handleRowClick"
    >
      <template #cell(created_at)="data">
        {{ data.item.created_at | date }}
      </template>

      <template #cell(value)="data">
        {{ data.item.value | value }}
      </template>

      <template #cell(email_transactions)="data">
        {{ data.item.customer.email }}
      </template>

      <template #cell(name_transactions)="data">
        {{ data.item.customer.name }}
      </template>

      <template #cell(status)="data">
        <b-badge
          pill
          :variant="status[data.item.status_id].variant"
        >
          {{ status[data.item.status_id].status }}
        </b-badge>
      </template>
    </b-table>

    <b-pagination
      v-model="currentPage"
      :per-page="10"
      :total-rows="filteredArray.length"
      align="center"
      class="mt-2"
      size="sm"
    />
  </b-card>
</template>

<script>
import {
  BCard, BTable, BPagination, BBadge, BFormSelect, BFormInput, BRow, BCol,
} from 'bootstrap-vue'

const status = {
  1: {
    status: 'Aprovado',
    variant: 'success',
  },
  2: {
    status: 'Não Autorizado',
    variant: 'danger',
  },
  3: {
    status: 'Revisão',
    variant: 'warning',
  },
  7: {
    status: 'Falha na Captura',
    variant: 'danger',
  },
  8: {
    status: 'Falha na Recorrência',
    variant: 'danger',
  },
  9: {
    status: 'Criado',
    variant: 'success',
  },
  10: {
    status: 'Inativa',
    variant: 'danger',
  },
  11: {
    status: 'Aguardando Pagamento',
    variant: 'secondary',
  },
  12: {
    status: 'Expirado',
    variant: 'danger',
  },
  13: {
    status: 'Pago',
    variant: 'success',
  },
  14: {
    status: 'Baixado',
    variant: 'danger',
  },
}

export default {
  components: {
    BCard,
    BTable,
    BPagination,
    BBadge,
    BFormSelect,
    BFormInput,
    BRow,
    BCol,
  },

  props: {
    fetchData: {
      type: Array,
      default: () => [],
    },

    fields: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      status,
      currentPage: 1,
      firstDate: null,
      lastDate: null,
      filterStatus: null,
    }
  },

  computed: {
    totalRows() {
      return this.fetchData.length
    },

    optionsStatus() {
      const statusArray = Object.entries(status).map(([value, { status: text }]) => ({
        value,
        text,
      }))

      return statusArray
    },

    filteredArray() {
      const { firstDate, lastDate, filterStatus } = this
      let data = this.fetchData

      if (firstDate) {
        data = data.filter(item => item.created_at > firstDate)
      }

      if (lastDate) {
        data = data.filter(item => item.created_at < lastDate)
      }

      if (filterStatus) {
        console.log(data)
        data = data.filter(item => item.status_id === +filterStatus)
      }

      data = data.sort((a, b) => {
        if (a.id > b.id) {
          return 1
        }
        if (a.id < b.id) {
          return -1
        }
        return 0
      })
      return data.reverse()
    },
  },

  methods: {
    handleRowClick(data) {
      this.$store.commit('integration/UPDATE_ORDER', data)
      this.$router.push('/detalhes')
    },
  },
}
</script>

<style>

</style>
